// eslint-disable-next-line import/prefer-default-export
export enum LoadingStatus {
  Uninitialized = 'uninitialized',
  Pending = 'pending',
  Idle = 'idle',
  Errored = 'errored'
}
